import { baseEnvironment, buildEnvironment } from './environment.interface';

export const environment = buildEnvironment(baseEnvironment, {
    showDevTools: true,
    useHeaderSearch: true,
});